
define('text!fusion/ui/controls/fusion-radiogroup.html',[],function () { return '<div class="fusion-radio-group" data-bind="controlBehavior: { validationObservable: selectedValue }">\r\n\r\n    <h6 class="heading1" data-bind="text: headerText"></h6>\r\n\r\n    <label data-part="validationMessage_PART"></label>\r\n\r\n    <!-- ko transclude -->\r\n    <!-- /ko -->\r\n\r\n</div>\r\n\r\n';});

